<template>
    <div>
        <span>{{ $t('notification.tableViewAdded', {
            actor: $_.get(activity, 'actorUser.name'),
            tableName: $_.get(activity, 'payload.tableName'),
            viewName: $_.get(activity, 'payload.viewName')
        }) }}</span>
    </div>
</template>

<script>
export default {
    name: "TableViewAdded",
    props: {
        activity: {
            type: Object,
            required: true
        }
    }
};
</script>

